module.exports = __webpack_public_path__ + "media/kakas_m.5ea06b2f.mp3";